import { MutationTree } from 'vuex';
import axios from 'axios';
import {
  IVersionListStoreState,
  ITemplateVersionListRecord,
} from '@/types';
import { getDefaultState } from './state';

export const VersionListStoreMutations: MutationTree<IVersionListStoreState> = {
  setData: (state, data: ITemplateVersionListRecord[]) => {
    state.data = data;
  },
  setTotal: (state, number: number) => {
    state.total = number;
  },
  setLoading: (state, isLoading: boolean) => {
    state.loading = isLoading;
  },
  // Pagination
  setPaginationPage: (state, page: number) => {
    state.pagination.page = page;
  },
  setPaginationItemsPerPage: (state, itemsPerPage: number) => {
    state.pagination.itemsPerPage = itemsPerPage;
  },
  setPaginationServerItemsLength: (state, itemsLength: number) => {
    state.pagination.serverItemsLength = itemsLength;
  },
  setFilterIsDesc: (state, isDesc: '-' | '') => {
    state.filter.isDesc = isDesc;
  },
  resetState: (state) => {
    Object.assign(state, getDefaultState());
  },
  setTemplateId: (state, id: string) => {
    state.filter.id = id;
  },
  setFilterUpdatedAt: (state, updatedAt: string[]) => {
    if (updatedAt.length > 1) {
      const fromDate = new Date(updatedAt[0]).toLocaleDateString();
      const toDate = new Date(updatedAt[1]).toLocaleDateString();

      if (![fromDate, toDate].includes('Invalid Date')) {
        state.filter.updatedAt = `${fromDate} ~ ${toDate}`;
      }
    } else if (!updatedAt.length) {
      state.filter.updatedAt = '';
    }
  },
  resetTemplateId: (state) => {
    state.filter.id = '';
  },
  // cancelSource
  generateCancelSource: (state) => {
    state.cancelSource = axios.CancelToken.source();
  },
  cancelCancelSource: (state) => {
    state.cancelSource.cancel('cancel');
  },
};
